module.exports = __webpack_public_path__ + "img/Donation_process.3eb11266.jpg";